/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-05 11:32:28
 * @LastEditors: zhaoyuanbang zhaoyuanbang@longfor.com
 * @LastEditTime: 2025-09-09 16:11:51
 * @FilePath: /qd-yunjing-web/src/store/org.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import { defineStore } from 'pinia';

import { getOrgTreeRequest } from '@/api/modules/common';
import { OrgType } from '@/types';
import { LocalStorageService } from '@/utils/storage';
import { actions } from '@/hooks/index';
import { useAppStore } from '@/store/app';

import { getSpaceInfoRequest } from '@/api/modules/space-tree';
import {
  getLeafs,
  parseUrlParams,
  isEmpty,
  findNodeByKey,
  isSubsetOf,
  getType,
} from '@/utils/index';

const searchParams = parseUrlParams(window.location.href);
const orgId = searchParams.orgId || '';

const currentOrgInfo = LocalStorageService.get('_current_org_info') || {};
const currentOrgInfoList = LocalStorageService.get('_current_org_info_list') || [];
const currentOrgIds = LocalStorageService.get('_current_org_ids') || [];
let hasThirdPartId = '';
if (currentOrgInfo?.thirdPartId) {
  hasThirdPartId = currentOrgInfo?.thirdPartId;
}

type State = {
  orgList: OrgType[];
  currentOrgInfo: OrgType;
  hasThirdPartId: string;
  currentSpace: [];
  projectCheckStrictly: boolean;
  currentOrgInfoList: OrgType[];
  currentOrgIds: string[];
  spaceOptions: TypeObject[];
  space: string;
  spaceValue: string;
  activeMenu: string;
  multiSpace: any;
  c4OrgList: OrgType[];
  lanhaiEngineSpace: any;
};

const getAllOptionsPaths = (options: any, paths: any) => {
  options.forEach((option: any) => {
    if (option.children) {
      if (option.children.length) {
        paths.push(option.code);
        getAllOptionsPaths(option.children, paths);
      } else {
        paths.push(option.code);
      }
    }
  });
  return paths;
};
const getFirstOptionsPaths = (options: any, paths: any) => {
  options[0].children.forEach((option: any) => {
    if (option.children) {
      if (option.children.length) {
        getAllOptionsPaths(option.children, paths);
      } else {
        paths.push(option.code);
      }
    }
  });
  return paths;
};
const getAllOrgIds = (orgList: OrgType[]) => {
  const orgIds: string[] = [];

  const recursion = (list: OrgType[]) => {
    list.forEach((item) => {
      orgIds.push(item.orgId);
      if (item.children && item.children.length) {
        recursion(item.children);
      }
    });
  };
  recursion(orgList);

  return orgIds;
};

/**
 * @description: 根据 idPath 在组织树中查找对应的节点
 * @param orgList 组织树列表
 * @param idPath 组织的 idPath
 * @returns 找到的节点或 undefined
 */
const findNodeByIdPath = (
  orgList: OrgType[],
  idPath: string
): OrgType | undefined => {
  if (!orgList || orgList.length === 0 || !idPath) {
    return undefined;
  }

  const pathArray = idPath.split('|').filter(Boolean);

  const findNode = (
    nodes: OrgType[],
    targetId: string
  ): OrgType | undefined => {
    for (const node of nodes) {
      if (String(node.orgId) === targetId) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = findNode(node.children, targetId);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  // 从根节点开始逐层查找
  let currentNodes = orgList;
  let targetNode: OrgType | undefined;

  for (const id of pathArray) {
    targetNode = findNode(currentNodes, id);
    if (!targetNode) {
      return undefined;
    }
    // 如果还有下一层，继续查找
    currentNodes = targetNode.children || [];
  }

  return targetNode;
};

const getCityName = (result: any) => {
  // if (props.level === 2) {
  for (const firstLayer of result) {
    if (firstLayer.children) {
      for (const secondLayer of firstLayer.children) {
        delete secondLayer.children;
      }
    }
  }

  return result;
};
export const useOrgStore = defineStore('_org', {
  state: (): State => ({
    orgList: [],
    currentOrgInfo: { ...currentOrgInfo },
    hasThirdPartId,
    projectCheckStrictly: true,
    currentOrgInfoList: [...currentOrgInfoList],
    currentOrgIds: [...currentOrgIds],
    // 当前项目空间数据数据
    spaceOptions: [],
    space: '',
    spaceValue: '',
    currentSpace: [],
    // 左侧激活的目录
    activeMenu: '',
    multiSpace: [],
    c4OrgList: [],
    lanhaiEngineSpace: [],
  }),

  actions: {
    async getOrgTreeData() {
      const { data } = await getOrgTreeRequest();
      const orgList = data || [];

      // 空数组提前返回，避免后续无效操作
      if (!orgList.length) {
        this.orgList = [];
        this.c4OrgList = [];
        return;
      }

      this.orgList = orgList;
      this.c4OrgList = this.orgList.filter((i) => i.orgId === 'C4');

      const leafs = getLeafs<OrgType>(this.orgList);
      const firstOrgInfo = leafs[0];

      if (isEmpty(orgId)) {
        let value = firstOrgInfo;
        if (this.currentOrgInfo && Object.keys(this.currentOrgInfo).length) {
          value = this.currentOrgInfo;
        }
        this.setCurrentOrgInfo(value);

        if (
          !this.currentOrgIds
          || !this.currentOrgIds.length
          || !this.currentOrgIds.every((id) => !isEmpty(id))
          || !isSubsetOf(this.currentOrgIds, getAllOrgIds(this.orgList))
        ) {
          this.setCurrentOrgInfoList([value]);
        }
      } else {
        // 处理通过路由携带参数的形式跳转至云境系统
        const queryType = getType(orgId);
        if (queryType === 'array') {
          // 多个项目id
          const selected: OrgType[] = [];
          (orgId as string[]).forEach((id) => {
            const findInfo = findNodeByKey(this.orgList, id, 'orgId');
            if (findInfo) {
              selected.push(findInfo);
            }
          });
          if (selected.length) {
            this.setCurrentOrgInfoList(selected);
            this.setCurrentOrgInfo(selected.at(0) as OrgType);
          } else {
            this.setCurrentOrgInfoList([firstOrgInfo]);
            this.setCurrentOrgInfo(firstOrgInfo);
          }
        } else {
          const findInfo = findNodeByKey(this.orgList, orgId, 'orgId');
          if (findInfo) {
            this.setCurrentOrgInfo(findInfo);
            this.setCurrentOrgInfoList([findInfo]);
          } else {
            this.setCurrentOrgInfo(firstOrgInfo);
            this.setCurrentOrgInfoList([firstOrgInfo]);
          }
        }
      }
    },
    getSpaceInfor(id: string | number, code: string = '') {
      getSpaceInfoRequest({ orgId: id }).then((res) => {
        if (+res.code === 0 && res.data.length > 0) {
          const data = res.data;
          this.setCurrentSpace({ code: 0 });
          this.setSpaceValue(code || '0');
          this.setSpaceOptions(data);

          const allCheck: any = [];
          // allCheck = getAllOptionsPaths(data, []);
          this.setMultiSpace(allCheck);
        } else {
          this.setSpaceOptions([]);
          this.setMultiSpace([]);
        }
      });
    },
    setCurrentOrgInfo(info: OrgType, reload = false) {
      console.log('setCurrentOrgInfo', info);
      if (!(info?.id)) {
        return;
      }
      this.currentOrgInfo = {
        id: info.id,
        orgId: info.orgId,
        idPath: info.idPath,
        name: info.name,
        type: info.type,
        channel: info.channel,
        thirdPartId: info.thirdPartId || '',
        source: info.source || '',
      };
      if (info.thirdPartId) {
        this.hasThirdPartId = info.thirdPartId;
      } else {
        this.hasThirdPartId = '';
      }
      actions.setGlobalState({
        currentOrgInfo: this.currentOrgInfo,
        type: 'single',
      });
      LocalStorageService.set('_current_org_info', this.currentOrgInfo);
      localStorage.setItem('currentOrgId', info.orgId);
      this.getSpaceInfor(info.orgId);
      if (reload) {
        useAppStore().setCurrentDate(Date.now());
      }
    },

    setCurrentOrgInfoList(infos: OrgType[], reload = false) {
      this.currentOrgInfoList = infos.map((info) => ({
        id: info.id,
        orgId: info.orgId,
        idPath: info.idPath,
        name: info.name,
        type: info.type,
        channel: info.channel,
        thirdPartId: info.thirdPartId || '',
        source: info.source || '',
      }));
      this.currentOrgIds = infos.map((info) => info.orgId);
      actions.setGlobalState({
        currentOrgInfoList: this.currentOrgInfoList,
        currentOrgIds: this.currentOrgIds,
        type: 'multi',
      });
      LocalStorageService.set(
        '_current_org_info_list',
        this.currentOrgInfoList
      );
      LocalStorageService.set('_current_org_ids', this.currentOrgIds);

      if (reload) {
        useAppStore().setCurrentDate(Date.now());
      }
    },

    /**
     * @description: 获取当前选中区域的第一个有权限的项目节点数据
     */
    async getFirstProjectInfo(): Promise<OrgType> {
      if (this.orgList.length === 0) {
        await this.getOrgTreeData();
      }

      // 获取当前选中的组织节点
      const currentNode = findNodeByIdPath(
        this.orgList,
        this.currentOrgInfo.idPath
      );

      // 如果找到了当前节点，则获取该节点下的第一个项目（叶子节点）
      if (currentNode) {
        // 如果当前节点就是项目（type=6），直接返回
        if (String(currentNode.type) === '6') {
          return currentNode;
        }

        // 获取当前节点子树的所有叶子节点（项目）
        const subtree = currentNode.children && currentNode.children.length > 0
          ? [currentNode]
          : this.orgList;
        const leafs = getLeafs<OrgType>(subtree);

        if (leafs.length > 0) {
          return leafs[0];
        }
      }

      // 如果找不到当前节点或其子树没有项目，则返回全局第一个项目（降级处理）
      const leafs = getLeafs<OrgType>(this.orgList);
      return leafs[0];
    },
    // 设置区域
    setCurrentSpace(info: any) {
      this.currentSpace = info;
    },
    setProjectCheckStrictly(flag: boolean) {
      this.projectCheckStrictly = flag;
    },
    // 设置空间信息
    setSpaceValue(info: any) {
      this.spaceValue = info;

      let value;
      if (typeof info === 'string') {
        value = info;
      } else {
        value = info[info.length - 1];
      }
      for (let i = 0; i < this.spaceOptions.length; i++) {
        if (this.spaceOptions[i].code === value) {
          this.setCurrentSpace(this.spaceOptions[i]);
          break;
        }
        for (let j = 0; j < this.spaceOptions[i].children.length; j++) {
          if (this.spaceOptions[i].children[j].code === value) {
            this.setCurrentSpace(this.spaceOptions[i].children[j]);
            break;
          }
        }
      }
    },
    setActiveMenu(data: string) {
      this.activeMenu = data;
    },
    setSpaceOptions(info: any) {
      this.spaceOptions = info;
    },
    setMultiSpace(data: any) {
      this.multiSpace = data;
    },
  },
});
